import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 25"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M20 21.977a1.5 1.5 0 0 1-2.552 1.07l-3.641-3.58q-.861.015-1.722.015-3.784 0-7.667-.28a3.5 3.5 0 0 1-3.234-3.18A51 51 0 0 1 1 11.5q0-1.98.12-3.473a3.5 3.5 0 0 1 3.24-3.212Q8.8 4.5 12.032 4.5q3.225 0 7.61.314a3.5 3.5 0 0 1 3.238 3.211Q23 9.519 23 11.5q0 2.459-.184 4.528A3.5 3.5 0 0 1 20 19.152zm-1-3.265a.5.5 0 0 1 .463-.498c1.27-.093 2.248-1.055 2.357-2.275Q22 13.916 22 11.5q0-1.944-.117-3.395a2.5 2.5 0 0 0-2.313-2.294q-4.352-.31-7.538-.311-3.194 0-7.601.313a2.5 2.5 0 0 0-2.315 2.294A43 43 0 0 0 2 11.5q0 2.412.18 4.433a2.5 2.5 0 0 0 2.31 2.272 106 106 0 0 0 9.508.259.5.5 0 0 1 .36.143l3.791 3.726a.5.5 0 0 0 .85-.356zM8 12.167a4 4 0 1 1 8 0 4 4 0 0 1-8 0m5.868-.744a.3.3 0 1 0-.424-.424l-1.89 1.89-.934-.935a.3.3 0 0 0-.424.425l1.146 1.146a.3.3 0 0 0 .424 0z",
      clipRule: "evenodd"
    }
  )
);
var SvgMessageReadOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MessageReadOutlined_default = SvgMessageReadOutlined;

export { MessageReadOutlined_default as default };
